<template>
  <ul v-if="items" role="menu">
    <template v-for="(item, i) of items">
      <li
        v-if="visible(item) && !item.separator"
        :key="item.label || i"
        :class="[
          item.badgeStyle,
          {
            'layout-root-menuitem': root,
            'active-menuitem': activeIndex === i && !item.disabled,
          },
          item.label
        ]"
        role="none"
      >
        <div class="arrow" v-if="item.items && root === true"></div>
        <div v-if="root">
          <span class="layout-menuitem-text">{{ item.label }}</span>
        </div>
        <router-link
          v-if="item.to"
          :to="item.to"
          :style="item.style"
          :class="[item.class, 'p-ripple', { 'p-disabled': item.disabled, 'active-route': isCurrentModule(item) }]"
          :target="item.target"
          exact
          @click.native="onMenuItemClick($event, item, i)"
          @mouseenter.native="onMenuItemMouseEnter(i)"
          role="menuitem"
          v-ripple
        >
          <i :class="['layout-menuitem-icon', item.icon]"></i>
          <span class="layout-menuitem-text">{{ item.label }}</span>
          <i
            v-if="item.items"
            class="pi pi-fw pi-angle-down layout-submenu-toggler"
          ></i>
          <span v-if="item.badge" class="menuitem-badge">{{ item.badge }}</span>
        </router-link>
        <a
          v-if="!item.to"
          :href="item.url || '#'"
          :style="item.style"
          :class="[item.class, 'p-ripple', { 'p-disabled': item.disabled }]"
          :target="item.target"
          @click="onMenuItemClick($event, item, i)"
          @mouseenter="onMenuItemMouseEnter(i)"
          role="menuitem"
          v-ripple
        >
          <i :class="['layout-menuitem-icon', item.icon]"></i>
          <span class="layout-menuitem-text">{{ item.label }}</span>
          <i
            v-if="item.items"
            class="pi pi-fw pi-angle-down layout-submenu-toggler"
          ></i>
          <span v-if="item.badge" class="menuitem-badge">{{ item.badge }}</span>
        </a>
        <div class="layout-menu-tooltip" v-if="root">
          <div class="layout-menu-tooltip-arrow"></div>
          <div class="layout-menu-tooltip-text">{{ item.label }}</div>
        </div>
        <transition name="layout-submenu-container">
          <AppSubmenu
            v-show="item.items && (root ? true : activeIndex === i)"
            :items="visible(item) && item.items"
            :menuActive="menuActive"
            :layoutMode="layoutMode"
            @menuitem-click="$emit('menuitem-click', $event)"
          ></AppSubmenu>
        </transition>
      </li>
      <li
        class="p-menu-separator"
        :style="item.style"
        v-if="visible(item) && item.separator"
        :key="'separator' + i"
        role="separator"
      ></li>
    </template>
  </ul>
</template>
<script>
import EventBus from "./event-bus";
import { menuPathFor } from "./listViewRegistry";

// Menu targets are written unencoded ("/reports/Won Orders"); compare them decoded.
function samePath(a, b) {
  const decode = (p) => {
    try {
      return decodeURI(p);
    } catch (e) {
      return p;
    }
  };
  return decode(String(a)) === decode(String(b));
}

export default {
  name: "AppSubmenu",
  props: {
    items: Array,
    layoutMode: String,
    menuActive: Boolean,
    root: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeIndex: null,
    };
  },
  computed: {
    // The menu path of the module on screen, from the current route - so the highlight follows
    // every navigation, Back and Forward included (2026-09-27). See menuPathFor.
    // The record type the page on screen publishes ("Task" on a task's page, 2026-09-28) picks
    // Tasks over Activities for the /activities/:id pages the two kinds share.
    currentModulePath() {
      const recordType = this.$store ? this.$store.getters["getBreadcrumbRecordType"] : "";
      return menuPathFor(this.$route, this.$router, recordType);
    },
  },
  mounted() {
    EventBus.$on("reset_active_index", () => {
      if (this.layoutMode === "horizontal" || this.layoutMode === "slim") {
        this.activeIndex = null;
      }
    });
  },
  methods: {
    onMenuItemClick(event, item, index) {
      if (item.disabled) {
        event.preventDefault();
        return;
      }

      //execute command
      if (item.command) {
        item.command({ originalEvent: event, item: item });
        event.preventDefault();
      }

      if (item.items) {
        event.preventDefault();
      }

      if (this.root) {
        this.$emit("root-menuitem-click", {
          originalEvent: event,
        });
      }

      if (item.items) {
        this.activeIndex = index === this.activeIndex ? null : index;
      }

      this.$emit("menuitem-click", {
        originalEvent: event,
        item: item,
      });
    },
    isMobile() {
      return window.innerWidth <= 640;
    },
    isCurrentModule(item) {
      if (!item.to || !this.currentModulePath) return false;
      return samePath(item.to, this.currentModulePath);
    },
    onMenuItemMouseEnter(index) {
      if (
        this.root &&
        this.menuActive &&
        (this.layoutMode === "horizontal" || this.layoutMode === "slim") &&
        !this.isMobile()
      ) {
        this.activeIndex = index;
      }
    },
    visible(item) {
      return typeof item.visible === "function"
        ? item.visible()
        : item.visible !== false;
    },
    showHideUL(className, property) {
      try {
        let a = document.getElementsByClassName(className)
        if (a.length) {
          let lastChild = a[a.length - 1]
          if (lastChild.children && lastChild.children.length === 2) {
            let lastGrandChild = lastChild.children[lastChild.children.length - 1]
            if (lastGrandChild && lastGrandChild.nodeName === 'UL') {
              lastGrandChild.style.display = property
            }
          }
        }
        
      } catch(e) {
        
      }
    },
  },
  components: {
    AppSubmenu: this,
  },
};
</script>

<style scoped>
</style>
